// wait for dom to load...
window.addEventListener('DOMContentLoaded', (event) => {

  
    // sold out filter cookie data
    soldoutVisibility = localStorage.getItem("soldOutVisibility");
  
 
  
  
    if (soldoutVisibility === "invisible"){
        try {
            removeSoldout();
            togglezworth.classList.toggle("active")
          }
          catch(err) {
          } 
          finally {
          }
    }
    if (soldoutVisibility === "visible"){
        try {
            addSoldout();
            togglezworth.classList.remove("active")
        }
        catch(err) {
            
        } 
        finally {
          
        }
    }
    

  });



// this is affects the toggle button / link moving it and altering the color
const togglezworth = document.querySelector('.toggle')
togglezworth.addEventListener('click', () => {

if (togglezworth.classList.contains('active')) {
togglezworth.classList.remove('active')
localStorage.setItem("soldOutVisibility", "visible");
location.reload();
} else {
togglezworth.classList.add('active')
removeSoldout ()
}

});


// Hide sold out products
const hideSoldoutbttn = document.querySelector('.hide-sold-out')
const showSoldoutbttn = document.querySelector('.show-sold-out')

hideSoldoutbttn.addEventListener('click', removeSoldout)
const collectionGridSoldOut = document.querySelectorAll('.product-sold-out--visible');
function removeSoldout (){
localStorage.setItem("soldOutVisibility", "invisible");

for (const indentifiedSoldOut of collectionGridSoldOut) {

    indentifiedSoldOut.remove();
  }
}

// Show sold out products
showSoldoutbttn.addEventListener('click', addSoldout)
function addSoldout (){
localStorage.setItem("soldOutVisibility", "visible");
}

